import React from "react";

export default function WorkspaceHeader({
  workspaceLabel,
  pageLabel,
  user,
  stationLabel,
  onOpenCashier,
}) {
  const userName =
    user?.fullName || user?.full_name || user?.username || "Signed-in user";

  return (
    <header className="workspace-header">
      <nav className="workspace-header-breadcrumb" aria-label="Breadcrumb">
        <span>{workspaceLabel}</span>
        <span aria-hidden="true">/</span>
        <strong>{pageLabel}</strong>
      </nav>
      <div className="workspace-header-actions">
        <span className="workspace-header-station">
          <span aria-hidden="true" className="workspace-status-dot" />
          {stationLabel}
        </span>
        {onOpenCashier && (
          <button
            type="button"
            className="btn btn-primary workspace-open-cashier"
            onClick={onOpenCashier}
          >
            Open cashier
          </button>
        )}
        <span className="workspace-header-user" title={userName}>
          {userName}
        </span>
      </div>
    </header>
  );
}
